import React, { Component } from "react";
import "./salomCardForm.scss";
import axios from 'axios';

import ReactGA from "react-ga";

import Fade from "react-reveal";
import { env } from "../../shared/environment";

import InputMask from "react-input-mask";
import Loading from "../../shared/components/loading";
import Four from "../../shared/assets/pdfFiles/Согласие_на_обработку_персональных_данных.pdf";
import errorIcon from "../../shared/assets/images/alert-circle.svg"

import Confirmation from "./Confirmation/Confirmation";

ReactGA.initialize("UA-132213272-1", { standardImplementation: true });

class SalomCardForm extends Component {
    url = env.baseUrl;
    isLoading = false;
    isMobileValid = true;

    constructor(props) {
        super(props);

        this.state = {
            mobilePhone: "",
            loading: false,
            pureMobilePhone: "",
            isMobileValid: true,
            isMobileEmpty: false,
            activeSendBtn: false,
            applicationId: '',
            errorMessage: '',
            openModal: false
        };

        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onMobilePhoneChange = this.onMobilePhoneChange.bind(this);
        this.onMobilePhoneChangeBlur = this.onMobilePhoneChangeBlur.bind(this);
    }

    onMobilePhoneChange(event) {
        this.setState({
            mobilePhone: event.target.value
        }, () => {
            this.setState({
                pureMobilePhone: this.state.mobilePhone.replace(/[\s-+_]/g, "")
            }, () => {
                if (this.state.pureMobilePhone && this.state.pureMobilePhone.length === 12) {
                    this.setState({
                        isMobileValid: true,
                        isMobileEmpty: false,
                        activeSendBtn: true
                    },
                    )
                } else {
                    this.setState({
                        activeSendBtn: false
                    })
                }
            });

        });
    }

    onMobilePhoneChangeBlur() {
        if (this.state.pureMobilePhone && this.state.pureMobilePhone.length === 12) {
            this.setState({
                isMobileValid: true,
                isMobileEmpty: false
            })
        } else if (!this.state.pureMobilePhone && this.state.pureMobilePhone.length === 0) {
            this.setState({
                isMobileValid: true,
                isMobileEmpty: true,
                activeSendBtn: false
            })
        } else {
            this.setState({
                isMobileValid: false,
                isMobileEmpty: false,
                activeSendBtn: false
            })
        }
    }

    onFormSubmit(e) {
        e.preventDefault();

        if (this.state.isMobileValid) {
            this.setState({
                loading: true
            });

            // eslint-disable-next-line no-undef
            roistat.event.send('salom_website_send_phone');

            axios.post(`${this.url}public/application/add`, {
                fullname: 'Новая Заявка Салом',
                phone: this.state.pureMobilePhone
            })
                .then(response => {
                    if (response && response.data && response.data.code === 200) {
                        this.setState({
                            // mobilePhone: '',
                            loading: false,
                            applicationId: response.data.message,
                            openModal: true
                        });
                    }

                    this.setState({
                        loading: false
                    });
                }
                )
                .catch(error => {
                    this.setState({
                        loading: false,
                        isMobileValid: false,
                        activeSendBtn: false,
                        errorMessage: error.response.data.message
                    });
                })
        }
    }

    render() {
        const salomForm = (
            <>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="order-card-label text-center">
                                Заказать карту «Салом» бесплатно
                            </div>
                        </div>
                    </div>
                    <div className="row d-flex justify-content-center">
                        <div className="col-12 col-sm-9 col-md-8 col-lg-4">
                            <div className="form-label">Номер телефона</div>
                            <div className="form-inputField">
                                <InputMask
                                    mask="+\9\92 99 999-99-99"
                                    className={
                                        !this.state.isMobileValid ? "form-input invalid w-100" : this.state.isMobileEmpty ? "form-input invalid w-100" : "form-input w-100"
                                    }
                                    name="phone"
                                    type="tel"
                                    value={this.state.mobilePhone}
                                    onChange={this.onMobilePhoneChange}
                                    onBlur={this.onMobilePhoneChangeBlur}
                                    placeholder="+992 __ ___-__-__"
                                    alwaysShowMask={false}
                                />
                            </div>
                        </div>
                        {
                            this.props.windowWidth <= 992 ? (
                                <div className="col-12 col-sm-9 col-md-8 col-lg-4 ctm-condition-container">
                                    <div className="row d-flex justify-content-center">
                                        <div className="col-lg-4 d-flex">
                                            <div className="custom-checkbox-text">
                                                {this.state.isMobileValid
                                                    ? ""
                                                    : <div className="error mb-2">
                                                        <img src={errorIcon} alt="errorIcon" className="mr-1 mb-1" />
                                                        <span>{this.state.errorMessage
                                                            ? this.state.errorMessage
                                                            : 'Некорректно введен номер телефона'}</span>
                                                    </div>}
                                                Нажимая кнопку «Оставить заявку» я подтверждаю, что ознакомлен и согласен на <a href={Four} target="_blank" rel="noopener noreferrer">обработку  моих персональных данных</a>
                                            </div>
                                        </div>
                                        <div className="col-lg-3"></div>
                                    </div>
                                </div>
                            ) : null
                        }
                        <div className="col-12 col-sm-9 col-md-8 col-lg-3">
                            <div className="form-inputField">
                                <button
                                    disabled={!this.state.activeSendBtn}
                                    id="sendRequest"
                                    onClick={this.onFormSubmit}
                                    className="btn btn-success"
                                >
                                    Оставить заявку
                                </button>
                            </div>
                        </div>
                    </div>
                    {
                        this.props.windowWidth > 992 ? (
                            <div className="row  d-flex justify-content-center">
                                <div className="col-lg-6 d-flex">
                                    <div className="custom-checkbox-text">
                                        {this.state.isMobileValid
                                            ? ""
                                            : <div className="error mb-2">
                                                <img src={errorIcon} alt="errorIcon" className="mr-1 mb-1" />
                                                <span>{this.state.errorMessage
                                                    ? this.state.errorMessage
                                                    : 'Некорректно введен номер телефона'}</span>
                                            </div>}
                                        Нажимая кнопку «Оставить заявку» я подтверждаю, что ознакомлен и согласен на <a href={Four} target="_blank" rel="noopener noreferrer">обработку моих персональных данных</a>
                                    </div>
                                </div>
                                <div className="col-lg-1">
                                </div>
                            </div>
                        ) : null
                    }

                </div>
            </>
        );

        return (
            <div id="salomCardForm">
                {this.state.loading ? <Loading /> : null}
                <Fade>
                    <div className="salom-card-form purple">
                        {salomForm}
                    </div>
                </Fade>
                <Confirmation
                    show={this.state.openModal}
                    onHide={() => this.setState({ openModal: false })}
                    applicationId={this.state.applicationId}
                    phone={this.state.pureMobilePhone}
                />
            </div>
        );
    }
}

export default SalomCardForm;
